// extracted by mini-css-extract-plugin
module.exports = {"link":"Navigation_link__2R2_L","activeLink":"Navigation_activeLink__30C_B Navigation_link__2R2_L"};